export const SET_EMPLOYEE_ID = "SET_EMPLOYEE_ID";
export const RESET_EMPLOYEE_ID = "RESET_EMPLOYEE_ID";
